import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.waitForReady().pipe(
    map((isAuthenticated) => {
      if (isAuthenticated) return true;
      router.navigate(['/login']);
      return false;
    }),
  );
};

export const roleGuard: (roles: string[]) => CanActivateFn =
  (roles: string[]) => () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    return authService.waitForReady().pipe(
      map(() => {
        if (authService.isAuthenticated() && authService.hasRole(roles)) {
          return true;
        }
        router.navigate(['/']);
        return false;
      }),
    );
  };
